<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <v-icon 
        v-bind="props" 
        :class="iconClass"
        :size="iconSize" 
        :color="iconColor"
        :style="iconStyle"
      >
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ProgramacaoLocalizador',
  
  props: {
    // Código do localizador (obrigatório)
    codigo: {
      type: String,
      required: true
    },
    
    // Ícone a ser exibido
    icon: {
      type: String,
      default: 'mdi-code-tags'
    },
    
    // Tamanho do ícone
    iconSize: {
      type: [String, Number],
      default: 14
    },
    
    // Cor do ícone
    iconColor: {
      type: String,
      default: 'rgba(255,255,255,0.8)'
    },
    
    // Classes CSS adicionais
    iconClass: {
      type: String,
      default: 'mr-2'
    },
    
    // Posição personalizada
    position: {
      type: String,
      default: 'top-left', // top-left, top-right, bottom-left, bottom-right
      validator: (value) => ['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(value)
    },
    
    // Texto personalizado do tooltip
    prefixo: {
      type: String,
      default: 'LOCALIZADOR'
    }
  },
  
  computed: {
    iconStyle() {
      const positions = {
        'top-left': 'position: absolute; top: 4px; left: 4px;',
        'top-right': 'position: absolute; top: 4px; right: 4px;',
        'bottom-left': 'position: absolute; bottom: 4px; left: 4px;',
        'bottom-right': 'position: absolute; bottom: 4px; right: 4px;'
      }
      
      return positions[this.position] || positions['top-left']
    },
    
    tooltipText() {
      return `${this.prefixo}: ${this.codigo}`
    }
  }
}
</script>